import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getPageMetadata, updatePageMetadata } from '../../features/pageMetadata';

export default function RouteMetadata() {
  const { pathname, search } = useLocation();
  const { t, i18n } = useTranslation();
  useLayoutEffect(() => {
    updatePageMetadata(getPageMetadata(pathname, undefined, search, (key, fallback) =>
      t(key, { defaultValue: fallback }),
    ));
  }, [pathname, search, t, i18n.resolvedLanguage]);
  return null;
}
